const generatePresetLabel = (label, id) => {
  const idNumber = parseInt(id.split('-').pop(), 10);

  return `${label} ${idNumber}`;
};

export default generatePresetLabel;
